import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Page, PageHeader } from '../components/common';
import { SectionLeft, SectionMain } from '../components/sections';

const AboutUsPage: React.StatelessComponent = props => {
	return (
		<Page title="About Us">
			<Helmet>
				<meta charSet="utf-8"/>
				<meta
					name="description"
					content={`Mosaic Life is relevant, simple, and affordable life insurance. ` +
					`100% Canadian-owned and operated. We call Edmonton home, but service all of Canada.`}
				/>
				<title>About Mosaic Life | Mosaic Life</title>
			</Helmet>
			<SectionMain sectionClassName="my-4 section-lg">
				<PageHeader title="About Mosaic Life" />
				<p>In choosing an insurance company, it’s important to consider who is providing your protection.</p>
				<p>
					Mosaic Life is part of First Canadian Insurance Corporation, a life insurance company that has been in
					business for over 30 years. First Canadian is rated ‘A (Excellent)’ by A.M. Best, the major ratings agency for
					insurance companies.
				</p>
				<p>
					Our mission is to protect the lives of Canadians through relevant, simple, and affordable products. We are
					100% Canadian-owned and operated. We call Edmonton home, but we provide insurance across the country.
				</p>
				<p className="mb-0">
					We launched Mosaic Life out of our own need for protection. The Mosaic Life team is a bunch of 20 and
					30-somethings who needed coverage, but found the available options not relevant and too complicated. So we
					decided to reimagine how life insurance should work—100% online, totally flexible, no brokers, simple.
				</p>
			</SectionMain>
			<div className="mt-4 mt-md-0 py-md-4 landing-section">
				<div
					className="landing-section-img landing-section-img-02 landing-section-img-right"
					role="img"
					aria-label="A man holding a small child with their home and trees in the background"
				/>
				<SectionLeft columns={8} sectionClassName="section-lg">
					<h2 className="h3">Our Values</h2>
					<h4 className="mt-4">Act with integrity</h4>
					<p>
						Life insurance is about trust. We have to trust each other to be fair and honest at all times. That means we
						trust you'll be honest with us in setting up your coverage.
					</p>
					<h4 className="mt-4">Community</h4>
					<p>
						We care about giving back to the community that supports us. We're actively involved with the United Way,
						and we love it when our employees get involved.
					</p>
					<h4 className="mt-4">In it for the long haul</h4>
					<p>
						We protect our customers over long time horizons, which means we're careful in how we manage our business.
						This is reflected in our 'A (Excellent)' rating by A.M. Best.
					</p>
					<h4 className="mt-4">Customer Focused</h4>
					<p>
						We want to earn your business by giving you affordable and reliable coverage, and quality customer service.
					</p>
					<h4 className="mt-4">Different from the big guys</h4>
					<p>
						We want to bring a new approach to life insurance&mdash;one that is easy for people to use and affordable to
						buy. We do it all online because, like you, we like simple.
					</p>
					<h4 className="mt-4">Talk to us</h4>
					<p>
						We are taking insurance online, but we're not robots. If you have a question or a problem, please{' '}
						<a href="/contact-us">contact us</a> directly.
					</p>
				</SectionLeft>
			</div>
		</Page>
	);
};
export default AboutUsPage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/AboutUsPage.tsx